import script from "./OpsSideNav.vue?vue&type=script&setup=true&lang=js"
export * from "./OpsSideNav.vue?vue&type=script&setup=true&lang=js"

import "./OpsSideNav.vue?vue&type=style&index=0&id=30aa3ea8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-30aa3ea8"]])

export default __exports__